/**
 * Opt-out for nested interactive controls inside PanZoomSurface content.
 *
 * PanZoom listens to native `pointerdown` on the viewport (bubble). React
 * `stopPropagation` on child handlers runs too late, so the surface still
 * registers the pointer and pans. Mark controls with this attribute instead.
 */
export const PAN_ZOOM_IGNORE_ATTR = "data-pan-zoom-ignore" as const;

const PAN_ZOOM_IGNORE_SELECTOR = `[${PAN_ZOOM_IGNORE_ATTR}]`;

export function isPanZoomIgnoredTarget(target: EventTarget | null): boolean {
	if (!(target instanceof Element)) {
		return false;
	}
	return target.closest(PAN_ZOOM_IGNORE_SELECTOR) != null;
}
